import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FileText, ScrollText } from "lucide-react";
import CoaPanel from "@/components/documents/CoaPanel";

export default function DocumentsPage() {
  const [tab, setTab] = useState("coa");

  return (
    <div className="space-y-4 p-4 lg:p-6" data-testid="documents-page">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 lg:w-12 lg:h-12 rounded-xl bg-gradient-to-br from-indigo-500 to-violet-600 flex items-center justify-center text-white shadow-md">
          <ScrollText className="w-5 h-5 lg:w-6 lg:h-6" />
        </div>
        <div>
          <h1 className="text-xl lg:text-3xl font-bold tracking-tight">Documents</h1>
          <p className="text-xs lg:text-sm text-muted-foreground">Generate, save and re-print structured company documents</p>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="w-full sm:w-auto flex overflow-x-auto" data-testid="documents-subtabs">
          <TabsTrigger value="coa" data-testid="documents-tab-coa" className="gap-2">
            <FileText className="w-4 h-4" />
            COA
          </TabsTrigger>
        </TabsList>

        <TabsContent value="coa" className="mt-4">
          <CoaPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
